import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useUploadAttachment() {
  return useMutation({
    mutationFn: async (file) => {
      const form = new FormData();
      form.append("file", file);
      const { data } = await apiClient.post("/attachments", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    },
  });
}
